export default(type) => {
    //判断是否手机访问
    var sUserAgent = navigator.userAgent.toLowerCase();
    if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent)) {
        let currentURL = ''
        if(type == '1') {
            setTimeout(() => {
                window.location.href=`https://xg.cmc.edu.cn/MStuHelp/#/`;//测试 正式
                // window.location.href=`http://192.168.168.27:8080/#/`;//本地
            }, 0);
        }else  if(type == '2'){
            // setTimeout(() => {//这里跳转到手机端报道地址
            //     window.location.href=`http://yx.gingkoc.edu.cn/YXPhone/Phone/index.html?code=123&state=state#/Login`;
            // }, 1000);
        }else{
            currentURL = window.location.href.split('#')[1]
            setTimeout(() => {
                window.location.href=`https://xg.cmc.edu.cn/MStuHelp/#${currentURL}`;//测试 正式
                // window.location.href=`http://192.168.168.27:8080/#${currentURL}`;//本地
            }, 0);
        }  
    } else {
        return;
    }   
}


// WEBPACK FOOTER //
// ./src/assets/js/mixins.js